import RomanApi from "@roman/shared/lib/net/romanApi";
import type { Banner } from "@roman/shared/types/Banner";
import useSWR from "swr";

type ResponseBanner = {
  banners: Banner[];
};

export const useGetBanners = () => {
  const { data, error, isLoading, mutate } = useSWR<ResponseBanner>("/banners", RomanApi.get);

  return {
    banners: data?.banners,
    isLoading: isLoading,
    error,
    mutate,
  };
};
